
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { timespanToString } from '@/libs/common/filters/format-timespan';

@Component({})
export default class TimeSpanText extends Vue {
    @Prop() fromDate!: string;
    @Prop({ default: null }) toDate!: string | null;
    private interval: any = null;
    protected text = '';

    @Watch('fromDate')
    fromDateChanged() {
        this.calculateText();
    }

    mounted() {
        this.calculateText();
        this.interval = setInterval(() => {
            this.calculateText();
        }, 1000);
    }

    private calculateText() {
        if (this.fromDate == this.toDate) {
            this.text = "--";
        }
        else {
            this.text = this.fromDate ? timespanToString(this.fromDate, this.toDate) : '';
        }
    }

    destroyed() {
        clearInterval(this.interval);
    }
}
